// CSV cell escaping, shared by browser exports and server-generated statements.

/**
 * Escape one CSV cell.
 *
 * Leading `=`, `+`, `-`, `@`, tab or CR are prefixed with an apostrophe: partner-
 * controlled text (licence labels, partner names) ends up in these files and
 * Excel/Sheets execute a leading formula character.
 */
export function escapeCsvValue(v: string | number): string {
  const raw = String(v)
  const s = /^[=+\-@\t\r]/.test(raw) ? "'" + raw : raw
  return /[",\n\r]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s
}
